import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { useContext } from "react"
import { AdminContext } from "../views/Admin"

const Highlighted = ({ text = "", highlight = "" }) => {
	if (!highlight.trim()) {
		return <span>{text}</span>
	}
	const regex = new RegExp(`(${highlight})`, "gi")
	const parts = text.split(regex)

	return (
		<span>
			{parts.filter(String).map((part, i) => {
				return regex.test(part) ? <mark key={i}>{part}</mark> : <span key={i}>{part}</span>
			})}
		</span>
	)
}

const ConfirmationDialog = ({ message, okCallback }) => {
	const adminContext = useContext(AdminContext)
	const confirmationDialogOpen = adminContext.confirmationDialogOpen
	const handleConfirmationDialogClose = adminContext.handleConfirmationDialogClose

    const handleOk = () => {
        okCallback()
        handleConfirmationDialogClose()
    }

	return (
		<Dialog open={confirmationDialogOpen} onClose={handleConfirmationDialogClose}>
			<DialogTitle>{"אזהרה!"}</DialogTitle>
			<DialogContent>
				<DialogContentText><Highlighted text={message?.message} highlight={message?.highlight}/></DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleConfirmationDialogClose}>ביטול</Button>
				<Button onClick={() => handleOk()} autoFocus>
					המשך
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default ConfirmationDialog
